import { render, staticRenderFns } from "./index-blog.vue?vue&type=template&id=617d8e8a&"
import script from "./index-blog.vue?vue&type=script&lang=js&"
export * from "./index-blog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports